export default __webpack_public_path__ + "media/images/right-0824b2a1.png";